var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('header', {
    staticClass: "row p12",
    staticStyle: {
      "background": "#f2f2f2"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "h-filter"
  }, [_vm.checkoutPermission('CREATE_BRAND') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'CreateBrand'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New ")])]) : _vm._e()], 1)]), _c('div', {
    staticClass: "table-control"
  }, [_c('table', {
    staticClass: "table wh800",
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "txt-center",
    attrs: {
      "width": "80px"
    }
  }, [_vm._v("No")]), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "80px"
    }
  }, [_vm._v("Image")]), _c('th', [_vm._v("Name")]), _c('th', {
    staticClass: "txt-center",
    attrs: {
      "width": "100px"
    }
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "txt-center",
    attrs: {
      "width": "100px"
    }
  }, [_vm._v("Sort Order")]), _vm.checkoutPermission('UPDATE_BRAND') || _vm.checkoutPermission('DELETE_BRAND') ? _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "100px"
    }
  }, [_vm._v(" Action ")]) : _vm._e()])]), _vm.checkoutPermission('LIST_BRAND') ? _c('tbody', _vm._l(_vm.data.brands, function (brand, brandIndex) {
    return _c('tr', {
      key: (brand, brandIndex),
      staticClass: "hover-list"
    }, [_c('td', {
      staticClass: "txt-center"
    }, [_vm._v(_vm._s(brand === null || brand === void 0 ? void 0 : brand.id))]), _c('td', {
      staticClass: "text-center"
    }, [_c('image-detail', {
      attrs: {
        "heightChange": '36px',
        "widthChange": '60px',
        "thumbnail": brand.imageUrl && _vm.getFullImage(brand.imageUrl) || require('@/assets/images/noImage.jpg')
      }
    })], 1), _c('td', [_vm._v(_vm._s(brand.name))]), _c('td', {
      staticClass: "txt-center"
    }, [brand.status == 'active' ? _c('span', {
      staticClass: "txt-success"
    }, [_vm._v("Active")]) : _c('span', {
      staticClass: "txt-danger"
    }, [_vm._v("Inactive")])]), _c('td', {
      staticClass: "txt-center"
    }, [_vm._v(_vm._s(brand.sortOrder))]), _vm.checkoutPermission('UPDATE_BRAND') || _vm.checkoutPermission('DELETE_BRAND') ? _c('td', {
      staticClass: "tr-right"
    }, [_vm.checkoutPermission('UPDATE_BRAND') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'EditBrand',
          query: {
            id: brand.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-info btn-xs h36"
    }, [_c('i', {
      staticClass: "fa fa-pen"
    })])]) : _vm._e(), _vm.checkoutPermission('DELETE_BRAND') ? _c('button', {
      staticClass: "btn btn-danger btn-xs h36 ml3",
      on: {
        "click": function ($event) {
          return _vm.popupModal('delete', brandIndex);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()], 1) : _vm._e()]);
  }), 0) : _vm._e()]), _vm.isFetching ? _c('TableLoading') : _vm._e(), _vm.isNoData ? _c('NoItem') : _vm._e()], 1), _c('div', {
    staticClass: "total ph12"
  }, [_c('div', {
    staticClass: "ul-xl-li go-left"
  }, [_vm._v("Total : " + _vm._s(_vm.data.pagination.total))]), _vm.data.pagination.totalPage > 0 ? _c('Pagination', {
    attrs: {
      "pagination": _vm.data.pagination.totalPage
    }
  }) : _vm._e()], 1)])]), _vm.display.modal.delete.show ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.closeModal
    }
  }), _c('div', {
    staticClass: "modal-md"
  }, [_vm._m(1), _vm._m(2), _c('div', {
    staticClass: "modal-footer border-top"
  }, [!_vm.isDeleting ? _c('button', {
    staticClass: "btn btn-info btn-xs go-right",
    on: {
      "click": _vm.deleteBrand
    }
  }, [_vm._v(" Yes ")]) : _c('button', {
    staticClass: "btn btn-info btn-xs go-right"
  }, [_vm._v("Loading...")]), _c('button', {
    staticClass: "btn btn-light-secondary btn-xs mr12 go-right",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" No ")])])])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "go-left",
    staticStyle: {
      "display": "inline-block",
      "position": "relative"
    }
  }, [_c('b', [_vm._v("Brands")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-header border-bottom txt-info"
  }, [_c('span', {
    staticClass: "txt-sm"
  }, [_vm._v("Delete")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "hidden",
      "padding": "16px"
    }
  }, [_c('span', [_vm._v("Do you want to delete this record?")])]);

}]

export { render, staticRenderFns }